import { isFunction } from '@utils/type/checker';

type HandlerType = (event: Event) => void;
type Options = {
    handler: HandlerType;
    exclude?: HTMLElement[];
};

export function onOutsideClick(
    node: HTMLElement,
    handlerOrOptions: HandlerType | Options | null
) {
    if (handlerOrOptions === null) {
        return {};
    }

    let options: Options = isFunction(handlerOrOptions)
        ? { handler: handlerOrOptions }
        : handlerOrOptions;

    function clickHandler(event: Event) {
        if (!(event.target instanceof HTMLElement || event.target instanceof SVGElement)) return;

        const target = event.target;

        if (node === target || node.contains(target)) return;

        if (options.exclude?.some(el => el && (el === target || el.contains(target)))) return;

        options.handler(event);
    }

    document.addEventListener('click', clickHandler, true);

    return {
        update(newHandlerOrOptions: HandlerType | Options | null) {
            if (newHandlerOrOptions === null) {
                document.removeEventListener('click', clickHandler, true);
                return;
            }

            options = isFunction(newHandlerOrOptions)
                ? { handler: newHandlerOrOptions }
                : newHandlerOrOptions;
        },
        destroy() {
            document.removeEventListener('click', clickHandler, true);
        },
    };
}
